export class ConfirmResult {
    Action: string = "";
    InstructionType: number = -1;
    Id: number = -1;
}


// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/dialogboxes/shared/confirm.model.ts